import { defineComponent as _defineComponent } from 'vue'
import { DataInstance } from '@busy-human/gearbox';
import { InviteLinks } from '@busy-human/opt-library';
import Loader from '@/components/loader.vue';
import { onBeforeMount, watch } from 'vue';

type Props = {
    instance: DataInstance<InviteLinks.Model> | null
    error: string | null
}
type Emits = {
    (e: 'createInstance'): void
    (e: 'restart'): void,
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'invite-create',
  props: {
    instance: null,
    error: null
  },
  emits: ["createInstance", "restart", "progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'createInstance'): void
    (e: 'restart'): void,
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    instance: DataInstance<InviteLinks.Model> | null
    error: string | null
}





onBeforeMount(() => {
    emit('createInstance')
})

watch(()=> props.instance, val =>{
    if(val){
        emit('progress')
    }
})


const __returned__ = { props, emit, DataInstance, InviteLinks, Loader, onBeforeMount, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})